import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["copyText"]
  connect() {
  }

  copy() {
    const content = this.copyTextTarget.textContent.trim();
    if (content) {
      navigator.clipboard.writeText(content).then(
        () => {
          alert("Copied to clipboard!");
        }
      );
    }
  }
}
